import { useCallback, useEffect, useMemo, useRef } from 'react';
export var useProgressBar = function useProgressBar(params) {
  var isActive = params.isActive,
    autoPlay = params.autoPlay,
    activeSlide = params.activeSlide,
    changeSlide = params.changeSlide,
    slides = params.slides,
    duration = params.duration,
    loop = params.loop;
  var progressBarRef = useRef(null);
  var onStepFinish = useCallback(function (index) {
    if (loop || !loop && index !== slides) {
      changeSlide(index === slides ? 1 : index + 1);
    }
  }, [slides, loop]);
  var onInit = function onInit(options) {
    progressBarRef.current = options;
  };
  useEffect(function () {
    var _progressBarRef$curre;
    if (((_progressBarRef$curre = progressBarRef.current) === null || _progressBarRef$curre === void 0 ? void 0 : _progressBarRef$curre.getCurrentStep()) !== activeSlide - 1) {
      var _progressBarRef$curre2;
      (_progressBarRef$curre2 = progressBarRef.current) === null || _progressBarRef$curre2 === void 0 ? void 0 : _progressBarRef$curre2.changeStep(activeSlide);
    }
  }, [activeSlide]);
  return useMemo(function () {
    return {
      mode: autoPlay ? 'auto' : 'manually',
      progress: 100,
      activeStep: autoPlay ? 0 : activeSlide - 1,
      infinite: loop,
      onStepFinish: onStepFinish,
      onFinish: function onFinish() {
        return onStepFinish(slides);
      },
      onInit: onInit,
      isActive: isActive,
      iterative: true,
      steps: slides,
      duration: duration
    };
  }, [activeSlide, autoPlay, slides, duration, loop, isActive]);
};